import * as React from 'react'
import styled from 'styled-components'
import ReactHtmlParser from 'react-html-parser';
import { ChangeBtn, EditBtn } from 'src/components/atoms/input/buttons'
import backend from 'src/api';



export const ProductRow = props => {
    const [state, setState] = React.useState({
        item: props.item,
        offerid: props.offerid
    })

    let sendToPrint = (product, uuid) => {
        const _state = {...state}
        let item = _state.item;
        item.status = 'waiting'
        setState({ ..._state, item });
        return backend
            .sendCardToPrint(uuid, product.uuid, (result) => {
                if (result) {
                    if(result.status === 'pending'){                        
                        item = result;                    
                        setState({ ..._state, item });
                    }else{
                        item.status = 'error'
                        setState({ ..._state, item });
                    }                    
                }
            })
            .then((result) => {
                return result
            })
    }

    const openCardEditor = item => {
        window.open(item.externalUrl, "_blank");
    }

    const getPrice = props => {
        if(props.total){
            return adjustPrice(props.total.amount)
        }else{
            let ret = 0
            props.prices.map((item)=> {                
                if(item.description === 'min'+props.quantity){                    
                    ret = item.amount
                }
            })
            return adjustPrice(ret)
        }
    }

    const adjustPrice = nbr => {
        return ((nbr/100).toFixed(2)).toString().replace(".", ",")
    }

    const showButtons = (item, offerid) => {
        if (item.status === "waiting") {
            return (
                <div>
                    <p>Lädt...</p>
                </div>
            )
        }else if (item.status === "error") {
            return (
                <div>
                    <p>Fehler, bitte versuchen Sie es später noch einmal</p>
                </div>
            )
        }else if (item.status === "designing") {
            return (
                <div>
                    <ChangeBtn onClick={() => openCardEditor(item)} rel="noopener">Bearbeiten</ChangeBtn>
                </div>
            )
        } else if (item.status === "approved") {
            return (
                <div>
                    <ChangeBtn onClick={() => openCardEditor(item)} rel="noopener">Ansehen</ChangeBtn>
                    <EditBtn style={{width: 'auto'}} status={true} onClick={() => sendToPrint(item, offerid)} rel="noopener">Druckfreigabe senden</EditBtn>
                </div>
            )
        } else {
            return (
                <div>
                    <ChangeBtn onClick={() => openCardEditor(item)} rel="noopener">Ansehen</ChangeBtn>
                </div>
            )
        }
    }

    return (
        <ProductItem>
            <img src={{ ...state }.item.photos[0]} />
            <div>
                <h4>
                    {{ ...state }.item.productType === "OBITUARY" ? 'Partezettel' : 'Gedenkbilder'} / {{ ...state }.item.name}</h4>
                    <p>€: <strong>{getPrice({ ...state }.item)}</strong></p>
                    {/* {console.log(getPrice({ ...state }.item))} */}
                <hr />
                <div className="description">{ReactHtmlParser({ ...state }.item.longDescription)}</div>
                <p className="status">Status: <strong>{{ ...state }.item.status}</strong></p>
                {showButtons({ ...state }.item, { ...state }.offerid)}

            </div>
        </ProductItem>
    )
}



const ProductItem = styled.div`
  display: flex;
  margin: 10px 0px 20px;
  padding: 10px;
  background-color: #d5e4e3;

  :last-child{
      margin: 10px 0px;
  }
  
  img{
      max-width: 350px;
      object-fit: contain;
  }
  div{
      width: 100%;
      padding: 10px 20px;
      h4{
          font-size: 18px;
          font-weight: 700;
          color: #4a4a4a;
      }
      hr{
          margin: 4px 0px;
          border: 1px solid #a7c9c2
      }
      .description{
          font-size: 16px;
          font-weight: 500;
          margin: 5px 0px;
      }
      .status{
        font-size: 13px;
        font-weight: 300;
        margin: 5px 0px;
        strong{
            font-weight: 700;
        }
      }
  }
`



// WEBPACK FOOTER //
// ./src/components/molecules/admin/ProductRow.tsx